export default __webpack_public_path__ + "static/media/232.72a29d80.png";